import React, { useEffect, useRef, useState } from 'react';
import {
   Box,
   Button,
   Checkbox,
   Divider,
   FormControlLabel,
   Grid,
   IconButton,
   List,
   ListItem,
   Paper,
   Tooltip,
   Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faUser, faGift } from '@fortawesome/free-solid-svg-icons';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle';
import {
   faFileEdit,
   faPrint,
   faTrashAlt,
   faClone,
   faDownload,
} from '@fortawesome/pro-duotone-svg-icons';
import { Layout } from '../../../configs/ui/constant';
import Axios from 'axios';
import Circle from '../../Chart/Circle';
import { QRCode } from 'react-qrcode-logo';
import Logo from '../../../assets/mocks/img/logo.png';
import styled from '@emotion/styled';
import ReactToPrint from 'react-to-print';
import ErrorPopup from '../../Error/ErrorPopup';
import LoadingPopup from '../../Loading/LoadingPopup';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import dayjs from 'dayjs';
import { ActLable } from '../../Status/StatusLabel';
import { GSBtoWording } from '../../../configs/helpers/GSBtoWording';
import { useSnackbar } from 'notistack';
const MyChip = styled('div')`
   padding: 0 0.5rem 0;
   display: inline-flex;
   align-content: center;
   align-items: center;
   justify-content: center;
   background-color: ${(props) => props.bgColor};
   border-radius: 2.5px;
   margin-right: 1rem;
   font-weight: 700;
   color: #fff;
   padding: 5px;
`;
const MyChipPrint = styled('div')`
   height: 40px;
   width: 40px;
   display: inline-flex;
   align-content: center;
   align-items: center;
   justify-content: center;
   background-color: ${(props) => props.bgColor};
   border-radius: 50%;
   margin-right: 1rem;
   color: #fff;
   font-family: 'GSB';
   padding: 5px;
`;
const MySpan = styled('span')`
   width: 100%;
   margin: 0 0.5rem;
`;
const DataSpan = styled('span')`
   font-weight: 700;
   margin: ${(props) => props.margin};
`;
const PaperPrint = styled('div')`
   width: 100%;
   text-align: center;
`;
const TitlePaper = styled('div')`
   width: 100%;
   background-color: ${Layout.primary};
   color: #fff;
`;
const TextPrint = styled('div')`
   font-size: 1.25rem;
   color: #515151;
   margin: 0;
   font-weight: 700;
   padding: 0.5rem;
`;

const TextValuePrint = styled('div')`
   font-size: 1.25rem;
   color: #000;
   margin: 0;
   font-weight: 700;
   padding: 0.5rem;
`;
const TextValuePrintH = styled('h2')`
   color: #000;
   margin: 0;
`;
const TextValuePrintB = styled('div')`
   font-size: 1.75rem;
   color: #000;
   margin: 0;
   font-weight: 700;
   padding: 0.5rem;
`;
const CenterSpace = {
   display: 'flex',
   alignContent: 'center',
   alignItems: 'center',
   justifyContent: 'space-between',
};

const ComponentToPrint = ({ printRef, nameSurvey, valueQR, data }) => (
   <div style={{ display: 'none' }}>
      <div ref={printRef}>
         <PaperPrint>
            <TitlePaper>
               <Typography variant={'h4'}>GSB Way Point</Typography>
            </TitlePaper>
            <br />
            <Box {...CenterSpace}>
               <Box width={1 / 2}>
                  <QRCode size={250} value={valueQR} logoImage={Logo} />
               </Box>
               <Box width={1 / 2} textAlign={'left'}>
                  <TextValuePrint>
                     {`แบบทดสอบ : ${data.surveyCode} : ${data.surveyNameTh}`}
                  </TextValuePrint>
                  <TextValuePrint>
                     หลักเกณฑ์ : {data.ruleCode} : {data.ruleName}
                  </TextValuePrint>
                  <div>
                     <TextValuePrint>{`ระหว่างวันที่ ${dayjs(
                        new Date(data.surveyStartDate),
                     ).format('DD MMM BB HH:mm')} น. ถึง ${dayjs(
                        new Date(data.surveyEndDate),
                     ).format('DD MMM BB HH:mm')} น.`}</TextValuePrint>
                  </div>
                  {/* {data.venue && <TextValuePrint>ณ {data.venue}</TextValuePrint>} */}
                  {/* <Box
              {...CenterSpace}
              justifyContent={"end"}
              style={{ placeContent: "start" }}
            >
              <TextValuePrint>คะแนนที่จะได้รับ : </TextValuePrint>
              <Box {...CenterSpace} justifyContent={"space-evenly"}>
                <PointPrintGSB
                  G={data.gPointPerPerson}
                  S={data.sPointPerPerson}
                  B={data.bPointPerPerson}
                />
              </Box>
            </Box> */}
               </Box>
            </Box>
         </PaperPrint>
      </div>
   </div>
);

const IconTitle = ({ icon, text }) => (
   <React.Fragment>
      <FontAwesomeIcon icon={icon} color={Layout.primary} />
      <MySpan>{text}</MySpan>
   </React.Fragment>
);
const PointGSB = ({ G, S, B }) => (
   <React.Fragment>
      <Box>
         <MyChip bgColor={'rgb(238,210,35)'}>{'for SOCIETY'}</MyChip>
         <DataSpan>{B}</DataSpan>
      </Box>
      <Box>
         <MyChip bgColor={'rgb(234,24,145)'}>{'with GOVERNANCE'}</MyChip>
         <DataSpan>{G}</DataSpan>
      </Box>
      <Box>
         <MyChip bgColor={'rgb(135,70,60)'}>{'through DIGITALIZATION'}</MyChip>
         <DataSpan>{S}</DataSpan>
      </Box>

      {/* <Box>
      <MyChip bgColor={"rgb(234,24,145)"}>{GSBtoWording("G")}</MyChip>
      <DataSpan>{G}</DataSpan>
    </Box>
    <Box>
      <MyChip bgColor={"rgb(135,70,60)"}>{GSBtoWording("S")}</MyChip>
      <DataSpan>{S}</DataSpan>
    </Box>
    <Box>
      <MyChip bgColor={"rgb(238,210,35)"}>{GSBtoWording("B")}</MyChip>
      <DataSpan>{B}</DataSpan>
    </Box> */}
   </React.Fragment>
);
// const PointPrintGSB = ({ G, S, B }) => (
//   <React.Fragment>
//     {G ? (
//       <Box>
//         <DataSpan margin={"0 5px"}>{G}</DataSpan>
//         <MyChipPrint bgColor={"rgb(234,24,145)"}>G</MyChipPrint>
//       </Box>
//     ) : (
//       ""
//     )}
//     {S ? (
//       <Box>
//         <DataSpan margin={"0 5px"}>{S}</DataSpan>
//         <MyChipPrint bgColor={"rgb(135,70,60)"}>S</MyChipPrint>
//       </Box>
//     ) : (
//       ""
//     )}
//     {B ? (
//       <Box>
//         <DataSpan margin={"0 5px"}>{B}</DataSpan>
//         <MyChipPrint bgColor={"rgb(238,210,35)"}>B</MyChipPrint>
//       </Box>
//     ) : (
//       ""
//     )}
//   </React.Fragment>
// );
const ValuePerson = ({ value }) => (
   <DataSpan margin={'0  2rem'}>{value}&nbsp;&nbsp;คน</DataSpan>
);
const ValueReward = ({ value }) => (
   <DataSpan margin={'0  2rem'}>{value}&nbsp;&nbsp;</DataSpan>
);
const useStyles = makeStyles((theme) => ({
   paper: {
      // backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      // backgroundColor: "#fff",
      width: '65%',
      borderRadius: '7.5px',
      maxHeight: '95vh',
      overflow: 'auto',
   },
   role: {
      color: '#5858FA',
   },
   title: {
      color: '#6E6E6E',
   },
   large: {
      width: theme.spacing(8),
      height: theme.spacing(8),
   },
   header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(1, 0),
   },
   content: {
      margin: theme.spacing(0, 1),
      width: '100%',
   },
   headerL: {
      margin: theme.spacing(1),
   },
   listStyle: {
      height: '65px',
   },
   flexGrid: {
      display: 'flex',
      alignItems: 'center',
   },
   qrPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '100%',
   },
   detailRight: {
      height: '280px',
      overflow: 'auto',
   },
}));
const View = (props) => {
   const classes = useStyles();
   const [isLoading, setIsLoading] = useState(true);
   const [isError, setIsError] = useState({
      error: false,
      errorStatus: '',
      errorMessage: '',
   });
   const [resp, setResp] = useState(null);
   const [data, setData] = useState({
      surveyGroupId: 0,
      surveyCode: '',
      surveyStatus: 0,
      surveyStatusDesc: '',
      surveyNameTh: '',
      surveyNameEn: '',
      surveyStartDate: '',
      surveyEndDate: '9',
      created_DT: '',
      rewardType: 0,
      rewardTypeDesc: '',
      isRewardLimit: false,
      rewardLimit: 0,
      canSubmitMultiple: false,
      isParticipateLimit: false,
      participateLimit: 0,
      initialPoints: 0,
      gPoint: 0,
      sPoint: 0,
      bPoint: 0,
      isPointLimit: false,
      gPointLimit: 0,
      sPointLimit: 0,
      bPointLimit: 0,
      paidGPoint: 0,
      paidSPoint: 0,
      paidBPoint: 0,
      ownerSurveyName: '',
      ownerCreateName: '',
      ruleCode: '',
      ruleNameTh: '',
      ruleNameEn: '',
      participateAmount: 0,
      pointRemaining: 0,
      rewardRemaining: 0,
      surveyQRCode: '',
   });
   const qrRef = useRef();
   const qrDownLoadRef = useRef();

   useEffect(() => {
      getData();
   }, []);
   const getData = () => {
      setIsLoading(true);
      Axios.get('/GSB/dashboard/survey/GetSurveyDashboard', {
         params: { SurveyGroupId: props.refID },
      })
         .then((response) => {
            setResp(response.data);
         })
         .catch((e) => {
            LogToBackend(e);
            setIsError({
               error: true,
               errorStatus: e.response.status,
               errorMessage: e.response.data.errorAppMessageTh
                  ? e.response.data.errorAppMessageTh
                  : 'เกิดข้อผิดพลาด',
            });
         })
         .finally(() => {
            setIsLoading(false);
         });
   };
   useEffect(() => {
      setSurveyData();
   }, [resp]);
   const setSurveyData = () => {
      if (resp) {
         setData({
            ...resp,
            data: resp,
            ruleName: resp.ruleNameTh,
            surveyName: resp.surveyNameTh,
            ownerSurveyName: resp.ownerSurveyName,
            ownerCreateName: resp.ownerCreateName,
            surveyQRCode: resp.surveyQRCode ? resp.surveyQRCode : '',
            perCent:
               resp.pointRemaining / resp.initialPoints
                  ? Math.fround(
                       (resp.pointRemaining / resp.initialPoints) * 100,
                    ).toFixed(2)
                  : 0,
         });
         setIsLoading(false);
      }
   };
   const handleEdit = () => {
      props.onClickEdit(data);
   };
   const handleDelete = () => {
      props.onClickDelete(data);
   };
   const { enqueueSnackbar } = useSnackbar();

   const handleCopyLink = () => {
      navigator.clipboard.writeText(
         process.env.REACT_APP_WEBAPP_ENDPOINT +
            '/surveydetail/' +
            data.surveyGroupId,
      );

      enqueueSnackbar('คัดลอกลิงค์สำเร็จ!!', {
         variant: 'success',
      });
   };
   if (isLoading) return <LoadingPopup />;
   if (isError.error)
      return (
         <ErrorPopup
            onClick={props.onClickClose}
            errorStatus={isError.errorStatus}
            errorMessage={isError.errorMessage}
         />
      );

   const handleDownload = () => {
      const canvas = qrDownLoadRef.current.canvas.current;
      if (!canvas) return;

      console.log(canvas);

      const link = document.createElement('a');
      link.download = data.surveyNameTh + '.png';
      link.href = canvas.toDataURL('image/png');
      link.click();
   };

   return (
      <Paper className={classes.paper}>
         <div className={classes.header}>
            <Box
               display={'flex'}
               justifyContent={'center'}
               alignItems={'center'}
               alignContent={'center'}
            >
               <Typography variant={'h4'}>รายละเอียดแบบสอบถาม</Typography>
               <Tooltip title='Edit'>
                  <IconButton aria-label='แก้ไข' onClick={handleEdit}>
                     <FontAwesomeIcon color={'#00a2e8'} icon={faFileEdit} />
                  </IconButton>
               </Tooltip>
               <Tooltip title='Delete'>
                  <IconButton aria-label='ลบ' onClick={handleDelete}>
                     <FontAwesomeIcon color={'#ed1c24'} icon={faTrashAlt} />
                  </IconButton>
               </Tooltip>
            </Box>
            <IconButton
               className={classes.headerL}
               size={'small'}
               onClick={props.onClickClose}
            >
               <FontAwesomeIcon icon={faTimesCircle} />
            </IconButton>
         </div>
         <Box
            display={'flex'}
            alignItems={'flex-start'}
            flexDirection={'column'}
            fontSize={20}
         >
            <Box
               display={'flex'}
               justifyContent={'space-around'}
               alignItems={'center'}
               alignContent={'center'}
            >
               <Box width={1 / 2}>
                  <Box>
                     <Box textAlign={'center'}>
                        <Circle series={[data.perCent]} />
                        <Typography variant={'body1'}>
                           {`คะแนนกิจกรรมคงเหลือ ${data.pointRemaining}/${data.initialPoints} คะแนน`}
                        </Typography>
                     </Box>
                  </Box>
               </Box>
               <Divider orientation={'vertical'} flexItem light />
               <Box width={1 / 2} className={classes.detailRight}>
                  <Box py={1} px={3}>
                     <Grid container>
                        {data.surveyCode && (
                           <React.Fragment>
                              <Grid item xs={6}>
                                 รหัสแบบสอบถาม
                              </Grid>
                              <Grid item xs={6}>
                                 {data.surveyCode}
                              </Grid>
                           </React.Fragment>
                        )}
                        {data.surveyStatusDesc && (
                           <React.Fragment>
                              <Grid item xs={6}>
                                 สถานะแบบสอบถาม
                              </Grid>
                              <Grid item xs={6}>
                                 <ActLable StatusType={data.surveyStatusDesc} />
                              </Grid>
                           </React.Fragment>
                        )}
                        {data.surveyNameTh && (
                           <React.Fragment>
                              <Grid item xs={6}>
                                 ชื่อแบบสอบถาม
                              </Grid>
                              <Grid item xs={6}>
                                 {data.surveyNameTh}
                              </Grid>
                           </React.Fragment>
                        )}
                        {data.ownerSurveyName && (
                           <React.Fragment>
                              <Grid item xs={6}>
                                 เจ้าของแบบสอบถาม
                              </Grid>
                              <Grid item xs={6}>
                                 {data.ownerSurveyName}
                              </Grid>
                           </React.Fragment>
                        )}

                        {data.ruleCode && (
                           <React.Fragment>
                              <Grid item xs={6}>
                                 รหัสหลักเกณฑ์
                              </Grid>
                              <Grid item xs={6}>
                                 {data.ruleCode}
                              </Grid>
                           </React.Fragment>
                        )}
                        {data.ruleNameTh && (
                           <React.Fragment>
                              <Grid item xs={6}>
                                 หลักเกณฑ์
                              </Grid>
                              <Grid item xs={6}>
                                 {data.ruleNameTh}
                              </Grid>
                           </React.Fragment>
                        )}

                        {data.ownerCreateName && (
                           <React.Fragment>
                              <Grid item xs={6}>
                                 พนักงานที่สร้างแบบสอบถาม
                              </Grid>
                              <Grid item xs={6}>
                                 {data.ownerCreateName}
                              </Grid>
                           </React.Fragment>
                        )}
                        <Grid item xs={6}>
                           วันที่สร้างแบบสอบถาม
                        </Grid>
                        <Grid item xs={6}>
                           {dayjs(new Date(data.created_DT)).format(
                              'DD/MM/BBBB HH:mm',
                           )}
                        </Grid>
                        <Grid item xs={6}>
                           ระยะเวลาของแบบสอบถาม
                        </Grid>
                        <Grid item xs={6}>
                           {`${dayjs(new Date(data.surveyStartDate)).format(
                              'DD/MM/BBBB HH:mm',
                           )} - ${dayjs(new Date(data.surveyEndDate)).format(
                              'DD/MM/BBBB HH:mm',
                           )}`}
                        </Grid>
                     </Grid>
                  </Box>
               </Box>
            </Box>
            <br />
            <Box width={'100%'}>
               <Grid container spacing={2}>
                  <Grid item lg={9} xs={12}>
                     <Paper elevation={3}>
                        <Box>
                           <List aria-label={'mailbox folders'}>
                              <ListItem divider className={classes.listStyle}>
                                 <Grid container>
                                    <Grid
                                       item
                                       xs={3}
                                       className={classes.flexGrid}
                                    >
                                       <IconTitle
                                          icon={faStar}
                                          text={'จำนวนคะแนนที่ให้ต่อคน'}
                                       />
                                    </Grid>
                                    <Grid item xs={9}>
                                       <Box
                                          {...CenterSpace}
                                          justifyContent={'space-evenly'}
                                       >
                                          <PointGSB
                                             B={data.bPoint}
                                             G={data.gPoint}
                                             S={data.sPoint}
                                          />
                                       </Box>
                                    </Grid>
                                 </Grid>
                              </ListItem>
                              <ListItem divider className={classes.listStyle}>
                                 <Grid container>
                                    <Grid
                                       item
                                       xs={3}
                                       className={classes.flexGrid}
                                    >
                                       <IconTitle
                                          icon={faStar}
                                          text={'จำนวนคะแนนที่ให้ไปทั้งหมด'}
                                       />
                                    </Grid>
                                    <Grid item xs={9}>
                                       <Box
                                          {...CenterSpace}
                                          justifyContent={'space-evenly'}
                                       >
                                          <PointGSB
                                             B={data.paidBPoint}
                                             G={data.paidGPoint}
                                             S={data.paidSPoint}
                                          />
                                       </Box>
                                    </Grid>
                                 </Grid>
                              </ListItem>
                              <ListItem divider className={classes.listStyle}>
                                 <Grid container>
                                    <Grid
                                       item
                                       xs={3}
                                       className={classes.flexGrid}
                                    >
                                       <IconTitle
                                          icon={faGift}
                                          text={'จำนวนของรางวัลคงเหลือ'}
                                       />
                                    </Grid>
                                    <Grid item xs={9}>
                                       <ValueReward
                                          value={data.rewardRemaining}
                                       />
                                    </Grid>
                                 </Grid>
                              </ListItem>

                              <ListItem className={classes.listStyle}>
                                 <Grid container>
                                    <Grid
                                       item
                                       xs={3}
                                       className={classes.flexGrid}
                                    >
                                       <IconTitle
                                          icon={faUser}
                                          text={'จำนวนผู้เข้าร่วมกิจกรรม'}
                                       />
                                    </Grid>
                                    <Grid item xs={9}>
                                       <ValuePerson
                                          value={data.participateAmount}
                                       />
                                       <FormControlLabel
                                          control={
                                             <Checkbox
                                                checked={data.canSubmitMultiple}
                                                disabled
                                                name={'canJoin'}
                                                color={'primary'}
                                                size={'small'}
                                             />
                                          }
                                          label={
                                             'สามารถเข้าร่วมกิจกรรมได้มากกว่า 1 ครั้ง'
                                          }
                                       />
                                    </Grid>
                                 </Grid>
                              </ListItem>
                           </List>
                        </Box>
                     </Paper>
                  </Grid>
                  <Grid item lg={3} xs={12}>
                     <Paper elevation={3} className={classes.qrPaper}>
                        <Box
                           p={2}
                           style={{
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center',
                              alignItems: 'center',
                           }}
                        >
                           <QRCode
                              logoImage={Logo}
                              value={
                                 process.env.REACT_APP_WEBAPP_ENDPOINT +
                                 '/surveydetail/' +
                                 data.surveyGroupId
                              }
                           />
                           <p style={{ textAlign: 'center' }}>
                              {process.env.REACT_APP_WEBAPP_ENDPOINT +
                                 '/surveydetail/' +
                                 data.surveyGroupId}
                           </p>
                           <Box
                              style={{
                                 width: '100%',
                                 display: 'flex',
                                 justifyContent: 'center',
                                 gap: '16px',
                                 alignItems: 'center',
                              }}
                           >
                              <Button
                                 variant={'outlined'}
                                 color={'primary'}
                                 startIcon={<FontAwesomeIcon icon={faClone} />}
                                 onClick={handleCopyLink}
                                 fullWidth
                              >
                                 คัดลอก
                              </Button>
                              <Button
                                 variant={'outlined'}
                                 color={'primary'}
                                 startIcon={
                                    <FontAwesomeIcon icon={faDownload} />
                                 }
                                 onClick={handleDownload}
                                 fullWidth
                              >
                                 ดาวน์โหลด
                              </Button>
                           </Box>
                           <Box style={{ width: '100%', marginTop: '16px' }}>
                              <ReactToPrint
                                 documentTitle={data.surveyNameTh}
                                 trigger={() => (
                                    <Button
                                       variant={'outlined'}
                                       color={'primary'}
                                       startIcon={
                                          <FontAwesomeIcon icon={faPrint} />
                                       }
                                       fullWidth
                                    >
                                       พิมพ์
                                    </Button>
                                 )}
                                 content={() => qrRef.current}
                              />
                           </Box>
                        </Box>
                     </Paper>
                  </Grid>
               </Grid>
               <ComponentToPrint
                  documentTitle={data.surveyNameTh}
                  printRef={qrRef}
                  valueQR={
                     process.env.REACT_APP_WEBAPP_ENDPOINT +
                     '/surveydetail/' +
                     data.surveyGroupId
                  }
                  nameSurvey={data.surveyNameTh}
                  data={data}
               />
               <div style={{ display: 'none' }}>
                  <QRCode
                     ref={qrDownLoadRef}
                     logoImage={Logo}
                     value={
                        process.env.REACT_APP_WEBAPP_ENDPOINT +
                        '/surveydetail/' +
                        data.surveyGroupId
                     }
                     size={1980}
                  />
               </div>
            </Box>
         </Box>
      </Paper>
   );
};

export default View;
